import classNames from 'classnames';
import React, { ReactElement } from 'react';
import { isMobile } from 'react-device-detect';
import { Button } from '../Button';
import './hosLogEditModal.scss';

type HosEditModalPropType = {
  undoButtonText: string;
  undoButtonFn?: () => void;
  proceedButtonText: string;
  proceedButtonFn?: () => void;
  message: string;
  title: string;
};

const HosLogEditModal = ({
  undoButtonText,
  undoButtonFn,
  proceedButtonText,
  proceedButtonFn,
  message,
  title,
}: HosEditModalPropType): ReactElement => {
  const buttonBackStyle = classNames('button-back', {
    'button-back-mobile': isMobile,
  });

  return (
    <div className="hos-edit-modal">
      <div className="modal-container">
        <h2>{title}</h2>
        <p>{message}</p>
        <div className="button-container">
          <Button
            title={`${proceedButtonText}`}
            onClick={proceedButtonFn}
            className={`${buttonBackStyle} button-cancel-edit`}
          />
          <Button
            title={`${undoButtonText}`}
            onClick={undoButtonFn}
            className={`${buttonBackStyle} button-return-to-edit`}
          />
        </div>
      </div>
    </div>
  );
};

export default HosLogEditModal;
